import React from "react";
import { useTranslation } from 'react-i18next';
import styles from "./css/GeneralEnergyTab.module.css";
import { GraphsCard } from "@/components/cards/GraphsCard";
import { PieGraph } from "@/components/graphs/PieGraph";
import { Favorites, CityAttributes } from "@/types";
import { SimpleYearComparisonChart } from "@/components/graphs/SimpleYearComparisonGraph";

interface GeneralEnergyTabProps {
  cityAttributes: CityAttributes | null;
  favorites: Favorites;
  setFavorites: (favorites: Favorites) => void;
  colors: {
    energy_consumption: { [key: string]: string };
    electrical_infrastructure?: { [key: string]: string };
    gas_emissions?: { [key: string]: string };
    [key: string]: { [key: string]: string } | undefined;
  };
}

export const GeneralEnergyTab: React.FC<GeneralEnergyTabProps> = ({ cityAttributes, favorites, setFavorites, colors }) => {
  const { t } = useTranslation('GeneralEnergyTab');
  const setFavourite = (id: string, isFavourite: boolean) => {
    setFavorites({ ...favorites, [id]: isFavourite });
  };

  // Dynamically extract years from energy_consumption_dict
  const years = cityAttributes?.energy_consumption_dict ? Object.keys(cityAttributes.energy_consumption_dict).sort() : [];
  const currentYear = years[0] || "2025";
  const futureYear = years[1] || "2040";

  return (
    <div className={styles.container}>
      <GraphsCard isFavourite={favorites.energyConsumption}  title={t('energyConsumption', { year: currentYear })} children={<PieGraph data={cityAttributes?.energy_consumption_dict[currentYear]} colors={colors.energy_consumption as {[key: string]: string}}  showLegend={true} />} setFavourite={setFavourite} id="energyConsumption" />
      <GraphsCard isFavourite={favorites.energyConsumption_future}  title={t('energyConsumption', { year: futureYear })} children={<PieGraph data={cityAttributes?.energy_consumption_dict[futureYear]} colors={colors.energy_consumption as {[key: string]: string}}  showLegend={true} />} setFavourite={setFavourite} id="energyConsumption_future" />
      <GraphsCard isFavourite={favorites.greenhouseEmissions} title={t('totalGhgEmissions')} children={<SimpleYearComparisonChart data={cityAttributes?.gas_emissions} />} setFavourite={setFavourite} id="greenhouseEmissions" />
    </div>
  );
};
